module.exports = __webpack_public_path__ + "img/ueber-mich_960.fe6bb38a.png";